import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_GENERAL_REQUESTS:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.FETCH_GENERAL_REQUEST:
      return { ...state, [action.payload.Id]: action.payload };
    case type.CREATE_GENERAL_REQUEST:
      return { ...state, [action.payload.Id]: action.payload };
    case type.EDIT_GENERAL_REQUEST:
      return { ...state, [action.payload.Id]: action.payload };
    case type.DELETE_GENERAL_REQUEST:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
